import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from "./Nwreu.module.css"; // Same CSS as Nwreu
import Loader from "../Loader/Loader";

const ITEMS_PER_PAGE = 20;

const RefNwreu = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://nwreu-backend-seven.vercel.app/ref-nwreu"
        );
        setData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Sort data by date descending
  const sortedData = [...data].sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );

  // Pagination logic
  const totalPages = Math.ceil(sortedData.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentData = sortedData.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  // Compact pagination numbers
  const getPageNumbers = () => {
    const pages = [];
    const delta = 2;
    const left = Math.max(2, currentPage - delta);
    const right = Math.min(totalPages - 1, currentPage + delta);

    pages.push(1);
    if (left > 2) pages.push("...");
    for (let i = left; i <= right; i++) pages.push(i);
    if (right < totalPages - 1) pages.push("...");
    if (totalPages > 1) pages.push(totalPages);

    return pages;
  };

  return (
    <div className={styles.TableContainer}>
      {loading ? (
        <Loader />
      ) : (
        <>
          <table className={styles.membersTable}>
            <thead>
              <tr>
                <th>Date</th>
                <th>Subject</th>
                <th>.</th>
              </tr>
            </thead>
            <tbody>
              {currentData.map((item, index) => (
                <tr key={startIndex + index}>
                  <td>{new Date(item.date).toLocaleDateString()}</td>
                  <td>
                    <a
                      href={item.subjectLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.link}
                    >
                      {item.subject}
                    </a>
                  </td>
                  <td>
                    <a
                      href={item.replyLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.replyLink}
                    >
                      {item.replyLink ? "." : ""}
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination Controls */}
          <div className={styles.pagination}>
            <button
              onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
              disabled={currentPage === 1}
            >
              Prev
            </button>

            {getPageNumbers().map((page, index) =>
              page === "..." ? (
                <span key={index} className={styles.ellipsis}>
                  …
                </span>
              ) : (
                <button
                  key={index}
                  className={
                    currentPage === page ? styles.activePage : styles.pageBtn
                  }
                  onClick={() => setCurrentPage(page)}
                >
                  {page}
                </button>
              )
            )}

            <button
              onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
              disabled={currentPage === totalPages}
            >
              Next
            </button>

            <span className={styles.jump}>
              Go to:
              <input
                type="number"
                min="1"
                max={totalPages}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    const value = Number(e.target.value);
                    if (value >= 1 && value <= totalPages) {
                      setCurrentPage(value);
                    }
                  }
                }}
              />
            </span>
          </div>
        </>
      )}
    </div>
  );
};

export default RefNwreu;
